<form #meetingForm="ngForm" class="col">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs d-print-none" (navChange)="navChange($event)">
    <li [ngbNavItem]="'information'">
      <a ngbNavLink>Information</a>
      <ng-template ngbNavContent>
        <div class="form-group row">
          <label class="col-2" for="date">Date</label>
          <div class="col-10" *ngIf="editing">
            <input type="date" id="date" #dateInput="ngModel" name="date" [(ngModel)]="meeting.date"
                   placeholder="Date of Meeting" class="form-control d-print-none">
          </div>
          <div class="col-sm-10" *ngIf="!editing">
            {{ meeting.date | date: 'shortDate' }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2" for="topic">Topic</label>
          <div class="col-sm-10" *ngIf="editing">
            <select class="form-control d-print-none" name="topic" id="topic" [(ngModel)]="meeting.topic"
                    #topicInput="ngModel">
              <ng-container *ngFor="let topic of meeting_topics">
                <option [value]="topic.name">{{ topic.name }}</option>
              </ng-container>
            </select>
          </div>
          <div class="col-sm-10" *ngIf="!editing">
            {{ meeting.topic }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2" for="participants">Participants</label>
          <div class="col-sm-10">
            <staff-select id="participants" [multiple]="true" [districtId]="districtId"
                          [(selected)]="meeting.participant_ids" (onChange)="meetingForm.form.markAsDirty();"
                          [editable]="editing"></staff-select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2" for="other_participants">Other Participants</label>
          <div class="col-sm-10" *ngIf="editing">
                <textarea class="form-control d-print-none" name="other_participants" id="other_participants"
                          #oParticipants="ngModel"
                          [(ngModel)]="meeting.other_participants"></textarea>
          </div>
          <div class="col-sm-10" *ngIf="!editing">
            {{ meeting.other_participants }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2" for="notes">Notes</label>
          <div class="col-sm-10" *ngIf="editing">
                <textarea class="form-control d-print-none" name="notes" id="notes" #notes="ngModel"
                          [(ngModel)]="meeting.notes"></textarea>
          </div>
          <div class="col-sm-10" *ngIf="!editing">
            {{ meeting.notes }}
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="'problems'">
      <a ngbNavLink>Problems</a>
      <ng-template ngbNavContent>
        <ng-container *ngFor="let problem of meeting.problems; let i = index">
          <div class="card" [ngClass]="getClass(problem.value)">
            <div class="card-header d-flex flex-row" [ngClass]="getClassFont(problem.value)">
              <div class="align-self-start align-self-center me-auto">{{ problem.name }}</div>
              <div class="align-self-end d-flex flex-row">
                <div class="input-group">
                  <select [(ngModel)]="problem.value" class="form-control" [name]="problem.name" [disabled]="!editing">
                    <option *ngFor="let v of values" [value]="v">{{ v | problemDesc }}</option>
                  </select>
                  <div class="input-group-append">
                    <button class="btn btn-primary d-print-none" (click)="toggleProblemsExpand(problem.name)">
                      <i class="fa fa-chevron-down" aria-hidden="true"
                         [ngClass]="{'fa-chevron-down':!problemsExpand(problem.name), 'fa-chevron-up': problemsExpand(problem.name)}"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <ul class="list-group list-group-flush d-print-none"
                [ngClass]="{'show':problemsExpand(problem.name), 'hide': !problemsExpand(problem.name)}">
              <ng-container *ngFor="let sub of problem.sub_problems">
                <li class="list-group-item">
                  <div class="d-flex flex-row">
                    <span class="align-self-start align-self-center me-auto">{{ sub.name }}</span>
                    <span class="align-self-end">
                      <span *ngIf="sub?.type === 'integer' || sub?.type === 'number'">
                        <span *ngIf="!editing">{{ sub.int_value | problemDesc }}</span>
                        <select *ngIf="editing" [(ngModel)]="sub.int_value" class="form-control" [name]="sub.name">
                          <option *ngFor="let v of values" [value]="v">{{ v | problemDesc }}</option>
                        </select>
                      </span>
                      <span *ngIf="sub?.type === 'string'">
                      <span *ngIf="!editing">{{ sub.str_value }}</span>
                      <textarea *ngIf="editing" class="form-control" [name]="sub.name"
                                [(ngModel)]="sub.str_value"></textarea>
                      </span>
                    </span>
                  </div>
                </li>
              </ng-container>

            </ul>
            <ul class="list-group list-group-flush d-none d-print-block">
              <li *ngFor="let sub of problem.sub_problems" class="list-group-item">
                <div class="d-flex flex-row">
                  <span class="align-self-start align-self-center me-auto">{{ sub.name }}</span>
                  <span class="align-self-end">
                      <span *ngIf="!editing">{{ sub.int_value | problemDesc }}</span>
                      <span *ngIf="sub?.type === 'string'">
                        {{ sub.str_value }}
                      </span>
                    </span>
                </div>
              </li>
            </ul>
          </div>
        </ng-container>
      </ng-template>
    </li>
    <li [ngbNavItem]="'strcons'">
      <a ngbNavLink>Strength / Concerns</a>
      <ng-template ngbNavContent>
        <meeting-strcons
          [ngClass]="{'showSelected':selectedSection==='strcons','hideSelected':selectedSection!=='strcons'}"
          [(meeting)]="meeting" (meetingChange)="onMeetingChange($event)" [edit]="editing"
          [strcons]="meeting_strcons"></meeting-strcons>
      </ng-template>
    </li>
    <li [ngbNavItem]="'nextsteps'">
      <a ngbNavLink>Next Steps</a>
      <ng-template ngbNavContent>
        <meeting-nextsteps
          [ngClass]="{'showSelected':selectedSection==='nextsteps','hideSelected':selectedSection!=='nextsteps'}"
          [(meeting)]="meeting" (meetingChange)="onMeetingChange($event)" [edit]="editing"
          [nextsteps]="meeting_nextsteps"></meeting-nextsteps>
      </ng-template>
    </li>

    <ng-container *ngIf="!editing">
      <li [ngbNavItem]="'edit'" class="ms-auto">
        <a ngbNavLink>Edit <span class="fa fa-pencil">&nbsp;</span></a>
      </li>
    </ng-container>
    <ng-container *ngIf="editing">
      <li class="ms-auto"></li>
      <ng-container *ngIf="active === 'problems'">
        <li ngbDropdown class="nav-item">
          <a href (click)="false" class="nav-link" ngbDropdownToggle>Add Problem</a>
          <div ngbDropdownMenu>
            <ng-container *ngFor="let problem of meeting_problems">
              <button ngbDropdownItem (click)="addProblem(problem)">{{ problem.name }}</button>
            </ng-container>
          </div>
        </li>
      </ng-container>
      <ng-container *ngIf="active === 'strcons'">
        <li ngbDropdown class="nav-item">
          <a href (click)="false" class="nav-link" ngbDropdownToggle>Add Strength / Concern</a>
          <div ngbDropdownMenu>
            <ng-container *ngFor="let strcon of meeting_strcons">
              <button ngbDropdownItem (click)="addStrcon(strcon)">{{ strcon.name }}</button>
            </ng-container>
          </div>
      </ng-container>
      <li [ngbNavItem]="'save'">
        <button type="button" class="btn btn-link" (click)="save(meetingForm)"
                [disabled]="!meetingForm.dirty && meetingForm.untouched">Save <span class="fa fa-floppy-o">&nbsp;</span>
        </button>
      </li>
    </ng-container>
  </ul>
</form>
<div [ngbNavOutlet]="nav" class="d-print-none mt-2"></div>

<div class="d-none d-print-block container container-fluid" style="page-break-before: always;" *ngIf="meeting">
  <h2>Meeting on {{meeting.date}}</h2>
  <div *ngFor="let item of nav.items" class="mt-4">
    <ng-container [ngTemplateOutlet]="item.contentTpl?.templateRef"></ng-container>
  </div>
</div>
